<template>
  <div class="body-div">
    <div class='page_row mb20 pt20' ref="pageRow">
      <div class="search">
        <div class="df search_arr">
          <div class="iconfont icon-fangdajing searchcion f32 pl10"  type='search'></div>
          <input @input="inputedit" type="text" class="search-input"  placeholder="请输入关键字" :focus="inputShowed" :value="searchValue"/>
        </div>
      </div>
    </div>
    <div class="h100"></div>

    <div class="search-flex-wrap scroll" :style="{'height':scrollHeight}">
      <div v-for="(item,index) in list" @touchstart="changeActive" @touchend="removeActive" class="h90 w-100"
           @click="toSongPage" :data-type="item.type" :data-index="item.cataIndex">
        <div class="h90 lh90 ml40 mr40 f32 border-bottom " :class="'item${item.cataIndex}'">
          {{item.cataIndex}}.{{item.name}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue"
import http from '@/util/http.js'
import '@/css/search.css'

var vm = vue;
export default {
  name: "search",
  data() {
    return {
      searchValue:'',
      list:[],
      inputShowed: true,
      scrollHeight:0
    }
  },
  methods: {
    inputedit:function(e){
      console.log(e.target.value)
      this.searchValue = e.target.value;
      if(!this.searchValue){
        this.list = []
        return
      }
      const that = this;
      http.post('/song/getContentsList', { search: this.searchValue }).then(res=> {
        if (res.code === 0) {
          const list = res.data;
          that.list = list;
        }
      });
    },
    toSongPage: function (e) {
      this.$router.push({
        name: 'songPage',
        query:{
          number: e.currentTarget.dataset.index,
          type:e.currentTarget.dataset.type
        }
      })
    },
    changeActive($event){
      $event.currentTarget.className = $event.currentTarget.className +  " bcEE";
    },
    removeActive($event){
      $event.currentTarget.className = $event.currentTarget.className.replace("bcEE","");
    }
  },
  mounted(){
      this.scrollHeight = (document.documentElement.clientHeight - this.$refs.pageRow.offsetHeight-80) + 'px'
  }
}</script>





// WEBPACK FOOTER //
// src/views/search.vue